export default "__VITE_ASSET__8fca62c6__"